import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  IMeetingRequest,
  TMeetingRequestTutorAmountData,
  TMeetingRequestStatus,
  TMeetingRequestType,
} from '.';
import { ApiPaths } from '../../../api/APIPaths';
import APIDataProvider, { TApiResponse } from '../../../api/ApiDataProvider';
import { TLessonTypes } from '../SectionSlice';

export type TGetMeetingRequests = {
  limit: number;
  offset: number;
  statuses?: TMeetingRequestStatus[];
  sortKey?: string;
  sortValue?: number;
  startDate?: string;
  endDate?: string;
  type?: TMeetingRequestType;
  lessonType?: TLessonTypes;
  includeTutorAmountData?: boolean;
};

const apiDataProvider = new APIDataProvider();

export const getMeetingRequests = createAsyncThunk(
  '/meeting-requests/list',
  async ({
    limit,
    offset,
    sortKey,
    sortValue,
    statuses,
    startDate,
    endDate,
    type,
    lessonType,
    includeTutorAmountData,
  }: TGetMeetingRequests) => {
    let path = `${ApiPaths.meetingRequests}?limit=${limit}&offset=${offset}`;

    if (statuses) {
      path += `&statuses=${statuses}`;
    }

    if (sortKey) {
      path += `&sortKey=${sortKey}`;
    }

    if (sortValue) {
      path += `&sortValue=${sortValue}`;
    }

    if (startDate) {
      path += `&startDate=${startDate}`;
    }

    if (endDate) {
      path += `&endDate=${endDate}`;
    }

    if (type) {
      path += `&type=${type}`;
    }

    if (lessonType) {
      path += `&lessonType=${lessonType}`;
    }

    if (includeTutorAmountData) {
      path += `&includeTutorAmountData=1`;
    }

    const response = await apiDataProvider.get<
      TApiResponse<{
        offset: number;
        limit: number;
        totalDocs: number;
        docs: Array<IMeetingRequest>;
        tutorAmountData?: TMeetingRequestTutorAmountData;
      }>
    >(path);

    return response.data;
  }
);

export const getMeetingRequestById = createAsyncThunk(
  '/meeting-requests/getOne',
  async ({ id }: { id: string }) => {
    const path = `${ApiPaths.meetingRequests}/${id}`;

    const response = await apiDataProvider.get<TApiResponse<IMeetingRequest>>(
      path
    );

    return response.data;
  }
);
